import { createContext, useContext } from 'react';
import type { Session, SessionUser } from '../lib/session';

export interface SessionState {
  session: Session;
  /** undefined: 확인 중, null: 로그아웃 */
  user: SessionUser | null | undefined;
}

export const SessionContext = createContext<SessionState | null>(null);

export function useSession(): SessionState {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('SessionProvider 밖에서 useSession을 사용했습니다.');
  return ctx;
}
